import axios from 'axios';
import { API_URL } from '@/config';

export default {

  create() {
    return axios.post(`${API_URL}/zabbix/problems`);
  },

  list() {
    return axios.get(`${API_URL}/zabbix/problems`);
  },

  listServices() {
    return axios.get(`${API_URL}/zabbix/services`);
  },

  login(userForm) {
    return axios.post(`${API_URL}/zabbix/login`, userForm);
  },

};
